import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core'
import { EventService, Facet, FacetValue } from '@spartacus/core'
import { Observable, Subscription } from 'rxjs'
import { MbHomepageFacetsConnector } from '../../connectors'
import { HomepageSearchService } from '../../services/homepage-search.service'
import { Router } from '@angular/router'
import { MbConstants } from '../../../shared/mb-constants'
import { SearchBoxSuggestionSelectedEvent } from '@spartacus/storefront'
import { SearchUtilsService } from '../../../search/services/search-utils.service'
import { shareReplay, take, tap } from 'rxjs/operators'
import { MbSpinnerService } from '../../../shared/services/mb-spinner.service'
import { DeviceDetectorService } from 'ngx-device-detector'

@Component({
  selector: 'mb-homepage-search-box-component',
  templateUrl: './mb-homepage-search-box.component.html',
  styleUrls: ['./mb-homepage-search-box.component.scss']
})
export class MbHomepageSearchBoxComponent implements OnInit, OnDestroy {
  isFilterActive: boolean = false
  filtersToggleStatus: boolean[] = []
  facets$: Observable<Facet[]> | undefined
  facetsNumber: number | undefined
  query: string | undefined
  searchTerm: string | undefined
  constants = MbConstants
  visibleFacetNumber: number = 3
  visibleFacetValuesNumber: number = 3
  showMoreFacetsOverall: boolean = false
  variableNumberOfVisibleFacets: number = this.visibleFacetNumber
  subscription: Subscription = new Subscription()
  isDesktopDevice = this.deviceDetectorService.isDesktop()

  constructor (protected mbHomepageFacetsConnector: MbHomepageFacetsConnector,
               protected homepageSearchService: HomepageSearchService,
               protected router: Router,
               protected cdRef: ChangeDetectorRef,
               protected eventService: EventService,
               protected searchUtilsService: SearchUtilsService,
               protected mbSpinnerService: MbSpinnerService,
               protected vcr: ViewContainerRef,
               protected deviceDetectorService: DeviceDetectorService) { }

  ngOnInit () {
    this.homepageSearchService.clearSearchQueries()
    this.subscription.add(this.homepageSearchService.homepageSearchQuery$
      .subscribe((searchQuery: string) => {
        this.query = searchQuery
        this.cdRef.detectChanges()
      }))

    this.subscription.add(this.eventService.get(SearchBoxSuggestionSelectedEvent)
      .subscribe((eventData: SearchBoxSuggestionSelectedEvent) => {
        this.homepageSearchService.addSearchTermToQuery(eventData.selectedSuggestion)
      }))
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  showFacets () {
    if (!this.facets$) {
      this.facets$ = this.mbHomepageFacetsConnector.getAll().pipe(
        take(1),
        tap(facets => this.facetsNumber = facets?.length || 0),
        shareReplay(1)
      )
    }
    this.isFilterActive = !this.isFilterActive
  }

  showMoreFacets () {
    this.showMoreFacetsOverall = !this.showMoreFacetsOverall
    if (this.showMoreFacetsOverall) {
      this.variableNumberOfVisibleFacets = this.facetsNumber || 0
    } else {
      this.variableNumberOfVisibleFacets = this.visibleFacetNumber
    }
  }

  showFilter (index: number) {
    if (!this.filtersToggleStatus[index]) {
      this.filtersToggleStatus = []
    }
    this.filtersToggleStatus[index] = !this.filtersToggleStatus[index]
  }

  handleSearchForTerm (searchTerm: string) {
    this.searchTerm = searchTerm;
    this.homepageSearchService.addSearchTermToQuery(searchTerm)
  }

  selectFacetValue (facetValue: FacetValue, facet: Facet) {
    if (facetValue) {
      facetValue.selected = !facetValue?.selected
    }

    const [decodedPrettyUrlSegment, decodedHashUrlSegment]: [string, string] = this.searchUtilsService.getUrlAndHashOfFacetValue(facetValue)

    if (facetValue.selected) {
      this.homepageSearchService.addFacetToQuery(
        { categoryName: facet?.name, facetValue: decodedPrettyUrlSegment, facetValueHash: decodedHashUrlSegment })
    } else {
      this.homepageSearchService.removeFacetFromQuery(
        { categoryName: facet?.name, facetValue: decodedPrettyUrlSegment, facetValueHash: decodedHashUrlSegment })
    }
  }

  goToSearchResults () {
    if(this.searchTerm && !this.query) {
      return this.router.navigate(['search/' + this.searchTerm]).catch((error: Error) => console.error(error)) 
    } else {
      return this.router.navigate(['search/' + this.query?.slice(0, this.query?.indexOf(this.constants.COLON_SYMBOL))], {
        queryParams: {
          query: this.query
        },
        queryParamsHandling: this.constants.MERGE,
      })
    }
  }
}
